export { default as FolderMoveSolidIcon } from './FolderMoveSolidIcon';
